import { getAffiliateGoods } from './getAffiliateGoods';

export const affiliateService = {
  getAffiliateGoods,
};
